var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"revisions-panel"},[_c('RevisionsList',{attrs:{"is-loading":_vm.loading,"revisions":_vm.revisionUiItems,"revisions-not-supported-message":_vm.revisionsNotSupportedMessage},on:{"revisionSelected":_vm.onRevisionSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }